/**
 * Gera as iniciais de um nome: primeira letra do primeiro e último segmento
 * com mais de 2 caracteres. Ex: "Conselho Federal de Medicina" → "CM"
 */
export function iniciais(nome: string | null | undefined, fallback = '?'): string {
    const partes = (nome ?? '')
        .trim()
        .split(/\s+/)
        .filter((p) => p.length > 0);
    if (partes.length === 0) return fallback;
    if (partes.length === 1) return partes[0][0].toUpperCase();
    return `${partes[0][0]}${partes[partes.length - 1][0]}`.toUpperCase();
}
